import React, { Suspense, lazy } from 'react'
import { useParams } from "react-router-dom";
import DOMPurify from 'dompurify';
import Header from './graphComponents/Header'
import Summary from './graphComponents/Summary'
import LoadingTable from '../tables/LoadingTable';
import ErrorFallback from "../../ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";
import getYear from "../../../../utils/getYear";

import '../tables/DataTable.scss'
const Table = ({ serverdata, size, slug }) => {
    const { year } = useParams();
    const tableData = () => {
        let volume = serverdata.volume === 'chronic-kidney-disease' ? "CKD" : 
                    (serverdata.volume === 'supplements-disparities' || serverdata.volume === 'supplement') ? "Supplements" 
                        : "ESRD";
        let tableName = serverdata.figureNumber.replace(" ", "").replace(".", "");
        const LazyTable = lazy(() => import(`../tables/${year}/${volume}/${tableName}`));
       
        return (
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Suspense fallback={<LoadingTable />}>
                    <LazyTable />
                </Suspense>
            </ErrorBoundary>
        );
    }
    
    if (process.env.REACT_APP_PRINT === "true") return TablePrint(serverdata, year, slug);

    return (
        <>
            <Header figureData={serverdata} slug={slug} />
            <div className="pt-4 print-table">
                {tableData()}
            </div>
            {getYear() < 2025 && 
                <div className="data-source" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(serverdata.methods, { ADD_ATTR: ['target'] }) }}>
                </div>
            }
            <Summary figureData={serverdata} />
        </>
    )
}

export default Table

const TablePrint = (serverdata, year, slug) => {
    return (
        <>
            <Header figureData={serverdata} slug={slug} />
            <div className="pt-4 print-table">
                {TablePrintData(serverdata, year)}
            </div>
            {getYear() < 2025 && 
                <div className="data-source" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(serverdata.methods, { ADD_ATTR: ['target'] }) }}>
                </div>
            }
            <Summary figureData={serverdata} />
        </>
    )    
}

const TablePrintData = (serverdata, year) => {
    let tableName = serverdata.figureNumber.replace(" ", "").replace(".", "");  
    let volume = serverdata.volume === 'chronic-kidney-disease' ? "CKD" : 
                (serverdata.volume === 'supplements-disparities' || serverdata.volume === 'supplement') ? "Supplements" 
                    : "ESRD";      
    const LazyTable = lazy(() => import(`../tables/${year}/${volume}/${tableName}`));

    const selections = Array.from(new Set(serverdata.figurePrint.flatMap(x => ({
        tab: x.tab,
        toggle: x.toggle
    }))));
    
    if (selections.length < 1)
    {        
        return (
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Suspense fallback={<LoadingTable />}>
                    <LazyTable />
                </Suspense>
            </ErrorBoundary>
        );
    }

    return (
        <div className="table-print-nav">          
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Suspense fallback={<LoadingTable />}>
                    {selections.map((item) => (
                        <div className="figure-print">
                            <div className="figure-print-title">
                                {item.tab}
                            </div>
                            <LazyTable selectedkey={item.toggle} /> 
                        </div>
                    ))}
                </Suspense>
            </ErrorBoundary>
        </div>
    );
};